import { getWindowSafe } from '@change-corgi/core/window';

/**
 * `undefined` on the server. `null` when the browser blocks storage (all cookies blocked): reading the
 * property itself throws a SecurityError, so this must run inside a try, not behind a `typeof` test.
 */
export function readStorageSafe(read: (window: Window) => Storage): Storage | null | undefined {
	const window = getWindowSafe();
	if (!window) return undefined;
	try {
		return read(window);
	} catch {
		return null;
	}
}
